import { Box } from '@mui/material';
import { useMemo } from 'react';
import { encodeQr, qrPath } from './qr';

/** A crisp, scalable QR code for `value` (always dark-on-white so every scanner reads it). */
export function QrCode({
  value,
  size = 200,
  label,
}: {
  value: string;
  size?: number;
  label: string;
}) {
  const { path, modules } = useMemo(() => {
    const matrix = encodeQr(value);
    return { path: qrPath(matrix, 4), modules: matrix.length + 8 };
  }, [value]);
  return (
    <Box
      sx={{
        width: size + 24,
        height: size + 24,
        p: '12px',
        borderRadius: '18px',
        bgcolor: '#fff',
        border: 1,
        borderColor: 'divider',
        boxShadow: '0 1px 2px rgba(16,24,40,0.05), 0 12px 24px -12px rgba(30,27,75,0.25)',
        flexShrink: 0,
      }}
    >
      <svg
        role="img"
        aria-label={label}
        viewBox={`0 0 ${String(modules)} ${String(modules)}`}
        width={size}
        height={size}
        shapeRendering="crispEdges"
        data-testid="qr-code"
      >
        <rect width={modules} height={modules} fill="#fff" />
        <path d={path} fill="#0B0D1A" />
      </svg>
    </Box>
  );
}
